import React from 'react';
import { API_BASE_URL } from '../lib/constants';

interface LoginFormProps {
  error?: string | null;
  setError?: (err: string | null) => void;
  loading?: boolean;
  setLoading?: (loading: boolean) => void;
  email: string;
  setEmail: (email: string) => void;
  password: string;
  setPassword: (password: string) => void;
  onSuccess?: () => void;
}

export function LoginForm({
  error,
  setError,
  loading,
  setLoading,
  email,
  setEmail,
  password,
  setPassword,
  onSuccess,
}: LoginFormProps) {
  const handleLoginSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (setError) setError(null);
    if (setLoading) setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/token/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: email, password })
      });
      if (!response.ok) throw new Error('Login failed');
      const data = await response.json();
      localStorage.setItem('token', data.access);
      if (onSuccess) onSuccess();
    } catch (err: any) {
      if (setError) setError('Login failed');
      if (setLoading) setLoading(false);
    }
    if (setLoading) setLoading(false);
  };

  return (
    <form onSubmit={handleLoginSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        required
        style={{ padding: 10, borderRadius: 6, border: '1px solid #ddd' }}
      />
      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={e => setPassword(e.target.value)}
        required
        style={{ padding: 10, borderRadius: 6, border: '1px solid #ddd' }}
      />
      {error && <div style={{ color: 'red', marginBottom: 8 }}>{error}</div>}
      <button type="submit" disabled={loading} style={{ padding: 10, borderRadius: 6, background: '#2563eb', color: '#fff', fontWeight: 600, border: 'none' }}>
        {loading ? 'Logging in...' : 'Login'}
      </button>
    </form>
  );
}
